export const FEES_ENDPOINT = 'https://www.erisx.com/product/fees/';
export const CONDITIONS_ENDPOINT =
  'https://www.erisx.com/regulation/disclosures/';
export const IRA_ACCOUNTS_ENDPOINT =
  'https://www.cboedigital.com/clearing/ira-accounts/';
export const INTERMEDIARIES_ENDPOINT =
  'https://www.cboedigital.com/intermediaries';
